import { useEffect } from "react";
import { db } from "../../firebase/config";
import { setFoodError } from "../../store/food/actions/setError";
import { TalesFood } from "../types/TalesFood";
import { setFoodData } from "../../store/food/actions/setData";
import { useDispatch, useSelector } from "react-redux";
import { usedHooks } from "../../store/site/selectors";
import { addUsedHook } from "../../store/site/actions/addUsedHook";

export default function useFoods() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useFoods")) {
      dispatch(addUsedHook("useFoods"));
      db.collection("food").onSnapshot((snapshot) => {
        if (snapshot.empty) {
          dispatch(setFoodError("Non è stato trovato nessun food"));
        } else {
          let foods: TalesFood[] = [];
          snapshot.docs.forEach((doc) => {
            foods = [...foods, doc.data() as TalesFood];
          });
          dispatch(setFoodData(foods));
        }
      });
    }
  }, [dispatch, hooks]);
}
